import React from 'react';
import '../Counter.css';

const TimeBreakdown = ({ timeUnits }) => {
  return (
    <div className="time-breakdown">
      <div className="time-unit">
        <div className="time-value">{timeUnits.years}</div>
        <div className="time-label">Years</div>
      </div>
      <div className="time-divider">•</div>
      <div className="time-unit">
        <div className="time-value">{timeUnits.months}</div>
        <div className="time-label">Months</div>
      </div>
      <div className="time-divider">•</div>
      <div className="time-unit">
        <div className="time-value">{timeUnits.days}</div>
        <div className="time-label">Days</div>
      </div>
    </div>
  );
};

export default TimeBreakdown;